/**
 * Bordered surface for grouped content (home-style panels, wizard sections).
 *
 * @returns Empty **`div`** with **`qz-card`**; append children.
 */
export function createCard(): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "qz-card";
  return el;
}
